import React, { useState } from "react";

import { CProgress } from "@coreui/react";
import { useSelector } from "react-redux";

import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Charts from "../../Charts";
import Loading from "../../Loading";
import StatisticTrailFilters from "../../StatisticTrailFilters";

import "./styles.scss";

const AtividadeTurma = ({ id }) => {
  const token = useSelector(state => state.user.token);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [userId, setUserId] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const changeFilter = selected => {
    setLoading(true);
    setRoomId(selected.roomId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);
    setUserId(selected.userId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      user_id: selected.userId,
      trail_id: id
    };

    axios
      .get(`${URL.api}statistics/trail_by_student`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        setData(
          resp.data.data.map(activity => ({
            ...activity,
            executions: activity.executions.map(execution => ({
              ...execution,
              grade: execution.items.reduce((acc, item) => {
                if (item.final_grade !== null) {
                  return acc + item.final_grade;
                }

                return acc;
              }, null),
              time: execution.items.reduce((acc, item) => {
                const difference =
                  (new Date(item.end) - new Date(item.start)) / 1000;

                return acc + difference;
              }, null)
            }))
          }))
        );
        setLoading(false);
      });
  };

  return (
    <>
      <div className="layoutTabela">
        <div className="layoutTabelaComparacao flex-column w-100">
          <StatisticTrailFilters
            id={id}
            onChange={changeFilter}
            selectUser
            required
          />
        </div>
        <div className="w-100">
          {loading ? (
            <div className="d-flex align-items-center justify-content-center w-100 p-5">
              <Loading />
            </div>
          ) : !userId ? (
            <div className="d-flex flex-column align-items-center justify-content-center w-100 py-4 px-3 text-muted">
              <img
                src={ImgNoData}
                style={{ height: "40vh" }}
                alt=""
                className="mb-4"
              />
              Selecione um usuário
            </div>
          ) : (
            <div className="w-100">
              <table className="table table-hover table-outline mb-0 d-none d-sm-table">
                <thead className="thead-light">
                  <tr>
                    <th>Atividade</th>
                    <th>Disciplina</th>
                    <th>Professor</th>
                    <th>Data</th>
                    <th>% Conclusão</th>
                    <th>Tempo médio</th>
                    <th>Nota</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(activity => (
                    <tr key={activity.id}>
                      <td>{activity.name}</td>
                      <td>{activity.discipline_name}</td>
                      <td>{activity.user_name}</td>
                      <td>
                        {activity.executions?.length > 0
                          ? new Date(
                              activity.executions[
                                activity.executions.length - 1
                              ].start.replace(" ", "T")
                            ).toLocaleDateString()
                          : ""}
                      </td>
                      <td>
                        <div className="clearfix">
                          <div className="float-left">
                            <strong>
                              {activity.executions?.length > 0
                                ? activity.executions[
                                    activity.executions.length - 1
                                  ].completion_percentage.toFixed(2)
                                : "0.00"}
                              %
                            </strong>
                          </div>
                        </div>
                        <CProgress
                          className="progress-xs"
                          color={
                            activity.executions?.length > 0
                              ? activity.executions[
                                  activity.executions.length - 1
                                ].completion_percentage > 50
                                ? "success"
                                : activity.executions[
                                    activity.executions.length - 1
                                  ].completion_percentage <= 50 &&
                                  activity.executions[
                                    activity.executions.length - 1
                                  ].completion_percentage >= 30
                                ? "warning"
                                : "danger"
                              : "danger"
                          }
                          value={
                            activity.executions?.length > 0
                              ? activity.executions[
                                  activity.executions.length - 1
                                ].completion_percentage
                              : 0
                          }
                        />
                      </td>
                      <td>
                        {activity.executions?.length > 0
                          ? activity.executions[
                              activity.executions.length - 1
                            ].time?.toFixed(2) || ""
                          : ""}
                      </td>
                      <td>
                        {activity.executions?.length > 0
                          ? activity.executions[
                              activity.executions.length - 1
                            ].grade?.toFixed(2) || ""
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div
                className="management-1statistics w-100"
                style={{ marginTop: "50px" }}
              >
                <div className="chart novo w-100">
                  <Charts
                    type="pie"
                    title="Percentual de conclusão"
                    data={{
                      labels: ["Não concluídos", "Concluídos"],
                      datasets: [
                        {
                          data: [
                            data.filter(
                              activity =>
                                activity.executions.length === 0 ||
                                activity.executions[
                                  activity.executions.length - 1
                                ].completion_percentage < 100
                            ).length,
                            data.filter(
                              activity =>
                                activity.executions.length > 0 &&
                                activity.executions[
                                  activity.executions.length - 1
                                ].completion_percentage >= 100
                            ).length
                          ],
                          backgroundColor: [
                            "rgba(255, 99, 132, 0.2)",
                            "rgba(75, 192, 192, 0.2)"
                          ],
                          borderColor: [
                            "rgba(255, 99, 132, 1)",
                            "rgba(75, 192, 192, 1)"
                          ],
                          borderWidth: 1
                        }
                      ]
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AtividadeTurma;
